(function (Drupal) {
  Drupal.behaviors.scrollToTop = {
    attach: function(context,settings) {
      PageProgress();
      function PageProgress() {
        let progressPath = document.querySelector('.progress-page path');
        let pathLength = progressPath.getTotalLength();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
        progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
        progressPath.style.strokeDashoffset = pathLength;
        progressPath.getBoundingClientRect();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

        let updateProgress = function () {
          let scroll = window.pageYOffset || document.documentElement.scrollTop;
          let height = document.documentElement.scrollHeight - window.innerHeight;
          let progress = pathLength - (scroll * pathLength / height);
          progressPath.style.strokeDashoffset = progress;
        };

        updateProgress();
        window.addEventListener('scroll', updateProgress);
      }

      window.addEventListener('scroll', function() {
        if (window.pageYOffset !== 0) {
          document.getElementById('scrollToTop').style.display = 'block';
        } else {
          document.getElementById('scrollToTop').style.display = 'none';
        }
      });

      document.getElementById('scrollToTop').addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  };
})(Drupal);
